/* eslint-disable import/no-extraneous-dependencies */

import { GridColDef } from '@mui/x-data-grid';
import { BrowseView, browseViewColumnAction } from '@pro4-erp/core-web';
import { Edit as EditIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AuditorRegistration } from '../types';
import { getAuditorRegistrationsForMe } from '../api/getAuditorRegistrationsForMe';
import { getBeautifiedLocalDate } from '@/core';

const BrowsePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const getClassificationName = (classification: AuditorRegistration['class']): string => {
    if (classification?.name && classification?.code) {
      return `${classification?.code} ${classification.name}`;
    }
    if (classification?.name) {
      return classification?.name;
    }
    return 'N/A';
  };
  const columns: GridColDef<AuditorRegistration>[] = [
    {
      ...browseViewColumnAction({
        field: 'actions',
        headerName: t('Open', { defaultValue: 'Open' }),
        icon: {
          element: <EditIcon />,
          color: 'primary',
        },
        onClick: ({ params }) => navigate(`/valid-registrations/${params.id}`),
      }),
      display: 'flex',
    },
    {
      field: 'note',
      display: 'flex',
      headerName: t('Note', { defaultValue: 'Note' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
    },
    {
      field: 'standard',
      display: 'flex',
      headerName: t('Standard', { defaultValue: 'Standard' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
      valueGetter(_, row) {
        return row.standard?.reference || 'N/A';
      },
    },
    {
      field: 'category',
      display: 'flex',
      headerName: t('Category', { defaultValue: 'Category' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
      valueGetter(_, row) {
        return row.cat?.name || 'N/A';
      },
    },
    {
      field: 'classification',
      display: 'flex',
      headerName: t('Classification', { defaultValue: 'Classification' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
      valueGetter(_, row) {
        return getClassificationName(row.class);
      },
    },
    {
      field: 'validDat',
      display: 'flex',
      headerName: t('Valid date', { defaultValue: 'Valid date' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      valueGetter(_, row) {
        return row.validDat ? getBeautifiedLocalDate(row.validDat) : 'N/A';
      },
    },
  ];

  return (
    <BrowseView
      title={
        <BrowseView.Title>
          {t('Valid registrations', { defaultValue: 'Valid registrations' })}
        </BrowseView.Title>
      }
      browserViewContainerSx={{
        height: '100vh',
      }}
      columns={columns}
      fetchData={(browseViewState) =>
        getAuditorRegistrationsForMe({ ...browseViewState, showOnlyValid: 'true' })
      }
      toolbar={<BrowseView.Toolbar showSearch showDensityBtn />}
    />
  );
};

export default BrowsePage;
